export default [
	{
		id: 1,
		job_title: "Intern tester",
		start_date: "2020-10-01",
		end_date: "2020-12-01",
		company: "Digital Thinkers ",
		description:
			"As and intern, i had few tasks, in the morning i needed check the status of the server, that was check the memory that its consums, the memory left, and if some error happend.After that check I needed do a test in the UI this need to be the same as the sistem design, also i check the functions in the app and gave feedback about the UX",
	},
	{
		id: 2,
		job_title: "Web developer",
		start_date: "2020-06-25",
		end_date: "2021-06-25",
		company: "NEO REDES ÓPTICAS DE OCCIDENTE ·",
		description:
			"As a web developer I worked in a little team of three. I working in frontend and backend in the modules that I made. Tasks are make modules for an application for the company, this application managment tickets for techs, this tickets save the current location of the browser which the session is open, allow take photos for the ticket, and save massage.All this time I have been working for frontend VueJs and the design with Vuetify using .For backend NodeJs where use MongoDB for data base, using express, cors, morgan an others.",
	},
	{
		id: 3,
		job_title: "Ingeniero de Desarrollo Jr.",
		start_date: "2021-06-27",
		end_date: "currently",
		company: "Nuxiba",
		description:
			"As a software engineer, I work developing designs created by a department with certain specifications, using ReactJS for the frontend also participating in the backend with python deploying app in apache .",
	},
];
